import React, { useEffect, useRef, useState } from "react";

import { IoIosWarning } from "react-icons/io";
import { Outlet, useNavigate, useRouteLoaderData } from "react-router-dom";

import { createNewChat } from "../actions/chatsAction.js";
import { getChatList } from "../api/chatApi.js";
import {
  getMessageList,
  getMessageResponse,
  sendMessage,
  stopResponseGeneration,
} from "../api/messageApi.js";
import Sidebar from "../components/Sidebar/index.jsx";

const HomePage = () => {
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState("");
  const [newChat, setNewChat] = useState(true);
  const [chatList, setChatList] = useState([]);
  const [activeChat, setActiveChat] = useState("");
  const [activeMsgId, setActiveMsgId] = useState("");
  const [isFetchingResponse, setisFetchingResponse] = useState(false);
  const [previousMessages, setPreviousMessages] = useState([]);
  const username = useRouteLoaderData("root");
  const [chatLoading, setChatLoading] = useState(true);
  const [chatListTotalCount, setChatListTotalCount] = useState(null);
  const chatListLimit = 20;
  const sidebarSkipRef = useRef(0);
  const [sidebarPage, setSidebarPage] = useState(0);
  const [userQueryAndReport, setUserQueryAndReport] = useState([]);
  const [dashboards, setDashboards] = useState([]);
  const [isDashboardLoading, setIsDashboardLoading] = useState(true);

  const config = {
    user_text: prompt,
  };

  const brandChangeHandler = (brandId) => {
    setNewChat(true);
  };

  useEffect(() => {
    if (username === "") navigate("/login");
  }, [username]);

  const getAllChats = async ({ skip, isReset = true }) => {
    const response = await getChatList({ limit: chatListLimit, skip });

    if (!response) return;
    const { data: result } = response;

    setChatListTotalCount(result.total_count);
    if (result.chats && result.chats.length) {
      setChatList((prev) => {
        const obj = [...prev, ...result.chats].reduce((acc, item) => {
          acc[item._id] = item;
          return acc;
        }, {});

        return isReset
          ? result.chats
          : Object.keys(obj).map((item) => obj[item]);
      });
    }
    setChatLoading(false);
  };

  let nIntervId;

  const getPromptResponse = async (msgId) => {
    const response = await getMessageResponse(msgId);
    const status = response.response_status;

    if (status === "pending") {
      if (response.tool_usage?.[0]?.tool_name) {
        setUserQueryAndReport(response.tool_usage[0]);
      }

      if (
        response?.table_metadata?.length &&
        response?.table_metadata?.[0]?.summary
      ) {
        clearInterval(nIntervId);
        nIntervId = null;
        setisFetchingResponse(false);
      }
    }

    if (status === "stopped") {
      clearInterval(nIntervId);
      nIntervId = null;
    }

    if (status === "success" || status === "failed") {
      if (newChat) {
        // await getAllChats({});
        setSidebarPage(0);
        sidebarSkipRef.current = 0;
        await getAllChats({});
      }
      clearInterval(nIntervId);
      nIntervId = null;
      setisFetchingResponse(false);
    }
  };

  const handleSend = async () => {
    setUserQueryAndReport([]);
    if (prompt !== "") {
      let chatId = activeChat;
      if (activeChat === "") {
        const activeBrand = localStorage.getItem("activeBrand");
        chatId = await createNewChat(setActiveChat, activeBrand);
      }
      setPrompt("");
      if (newChat) {
        setNewChat(false);
        getAllChats({});
      }
      const msgId = await sendMessage(chatId, config);

      // if (activeChat) {
      //   getMessageList({
      //     chatId: activeChat,
      //     setData: setPreviousMessages,
      //   });
      // }
      setActiveMsgId(msgId);
      setisFetchingResponse(true);
      nIntervId = setInterval(getPromptResponse, 3500, msgId);
    } else {
      return;
    }
  };

  const stopFetchingResponse = async () => {
    clearInterval(nIntervId);
    nIntervId = null;
    await stopResponseGeneration(activeMsgId);
    setisFetchingResponse(false);
  };

  useEffect(() => {
    setPrompt("");
  }, [activeChat, newChat]);

  useEffect(() => {
    if (newChat) {
      setActiveChat("");
    }
  }, [newChat]);

  return (
    <div className="flex flex-col">
      <div className="fixed top-0 left-0 bg-red-200 h-6 w-full z-[999] flex gap-1 justify-center items-center text-red-700 text-xs">
        <IoIosWarning color="red" size={14} />
        <p>This is a development environment. Do not use for production.</p>
      </div>
      <div className="flex relative top-6 justify">
        <Sidebar
          setNewChat={setNewChat}
          chatList={chatList}
          getAllChats={getAllChats}
          activeChat={activeChat}
          setActiveChat={setActiveChat}
          username={username}
          chatLoading={chatLoading}
          setChatLoading={setChatLoading}
          setChatList={setChatList}
          chatListTotalCount={chatListTotalCount}
          chatListLimit={chatListLimit}
          sidebarSkipRef={sidebarSkipRef}
          setPage={setSidebarPage}
          page={sidebarPage}
          isFetchingResponse={isFetchingResponse}
          stopFetchingResponse={stopFetchingResponse}
          setIsDashboardLoading={setIsDashboardLoading}
          isDashboardLoading={isDashboardLoading}
          setDashboards={setDashboards}
          dashboards={dashboards}
        />

        <div className=" flex-1 h-screenHeight overflow-hidden flex flex-col">
          <Outlet
            context={{
              chatList,
              newChat,
              prompt,
              setPrompt,
              isFetchingResponse,
              setPreviousMessages,
              previousMessages,
              userQueryAndReport,
              handleSend,
              stopFetchingResponse,
              brandChangeHandler,
              setIsDashboardLoading,
              setDashboards,
              activeChat,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
